const WHITELISTED_KEYS = new Set([
    'details',
    'meta'
]);

/**
 * Generates a copy of a given record with "flattened" nested keys, which cause indexing issues in Coralogix.
 * @param {ErrorRecord} record The error record to flatten.
 * @return {ErrorRecord}
 */
export default function flatten(record) {
    const newRecord = {};
    for (const key in record) {
        newRecord[key] = typeof record[key] === 'object' && !WHITELISTED_KEYS.has(key)
            ? JSON.stringify(record[key])
            : record[key];
    }
    return newRecord;
}
